export function toggleExclusion(
    excludedHypotheses: number[] | undefined,
    setExcludedHypotheses: (excludedHypotheses: number[]) => void | undefined,
    id: number,
    isExcluded: boolean,
) {
    if (!setExcludedHypotheses || !excludedHypotheses) {
        return;
    }

    if (isExcluded) {
        setExcludedHypotheses(excludedHypotheses.filter((e) => e !== id));
    } else {
        setExcludedHypotheses([...excludedHypotheses, id]);
    }
}
